import { Button, Chip } from '@mui/material';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import ActionLabels from 'utils/ActionLabelsDatagrid';
import ActionsMenu from 'utils/ActionsMenuDatagrid';
import { convertToMexicoTime } from 'utils/helpers/convertToMexicoTime';
import CurrencyFormatter from 'utils/helpers/CurrencyFormatter';

export const useTransactionsOpenPayHook = ({
  openPayAction,
  listOpenpay,
  cleanOpenPayAction,
  detailOpenPayAction,
  cleanDetailOpenPayAction,
  detailTransactionsOpenpay,
  actionReportTransactionsFraud,
  cleanReportTransactionsFraud,
  cleanReportPrepaidChargebackDetails,
  reportTransactionsFraud,
  actionReportTransactionsChargeback,
  reportTransactionsChargeback,
  transactionId,
  onClose,
}) => {
  const { payload } = listOpenpay || {};
  const { response } = detailTransactionsOpenpay || {};
  const { rows, pagination } = payload || {};

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useState({});
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(50);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState(false);
  const [isDialogOpenDetails, setIsDialogOpenDetails] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [action, setAction] = useState(null);
  const [openActionFraud, setOpenActionFraud] = useState(false);
  const [descriptionTransaction, setDescriptionTransaction] = useState('');
  const [loadingFraudAndChargeback, setLoadingFraudAndChargeback] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);

  const [error, setError] = useState(false);
  const [isError, setIsError] = useState(false);
  const [IdOrder, setIDorder] = useState('');
  const [mappedRows, setMappedRows] = useState([]);

  useEffect(() => {
    if (transactionId) {
      // setLoading(true);
      setIsDialogOpenDetails(true);
      detailOpenPayAction(transactionId);
    }
  }, [transactionId, detailOpenPayAction, setIsDialogOpenDetails]);

  useEffect(() => {
    if (response?.response?.status > 200) {
      setIsDialogOpenDetails(true);
      setDialogMessage('Error');
      setDialogMessage(response?.response?.data?.detail);
      setIsDialogOpen(true);
      setLoading(false);
    }
  }, [response]);

  useEffect(() => {
    // Verificar si searchParams tiene algún valor
    if (Object.keys(searchParams).length !== 0) {
      setLoading(true);
      openPayAction(page, size, searchParams)
        .then(() => setLoading(false))
        .catch(() => {
          setLoading(false);
        });
    }
    return () => {
      cleanOpenPayAction();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, openPayAction, cleanOpenPayAction]);

  useEffect(() => {
    // Verificar si searchParams tiene algún valor
    if (Object.keys(searchParams).length !== 0) {
      setLoading(true);
      openPayAction(page, size, searchParams)
        .then(() => setLoading(false))
        .catch(() => {
          setLoading(false);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, size]);

  useEffect(() => {
    if (listOpenpay?.status === 200) {
      setLoading(false);
    } else if (listOpenpay?.payload?.response?.status > 200) {
      setDialogMessage(listOpenpay?.payload?.response?.data?.detail);
      setIsDialogOpen(true);
      setLoading(false);
    }
  }, [listOpenpay]);

  const onSubmit = (data) => {
    const { from_date, to_date, authorization_code, masked_card } = data;

    const areDatesProvided = from_date !== '' && to_date !== '';
    const isAuthorizationOrCardProvided = authorization_code !== '' || masked_card !== '';

    if (areDatesProvided || isAuthorizationOrCardProvided) {
      setLoading(true);
      setPage(1);
      const filteredData = Object.fromEntries(
        // eslint-disable-next-line no-unused-vars
        Object.entries(data).filter(([_, value]) => value !== ''),
      );
      setSearchParams(filteredData);
      setErrorMessage('');
    } else {
      setErrorMessage(
        'Por favor, complete al menos uno de los siguientes campos: autorización, tarjeta o ambas fechas.',
      );
    }
  };

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  const handleChangePageSize = (newSize) => {
    setSize(newSize);
    setPage(1);
  };

  useEffect(() => {
    if (rows) {
      const updatedRows = rows.map((row) => ({
        ...row,
        id: `${row.id}`,
      }));
      setMappedRows(updatedRows);
    }
  }, [rows]);

  const handleIdButtonClick = (id) => {
    setIDorder(id);
    if (id) {
      setIsDialogOpenDetails(true);
      detailOpenPayAction(id)
        .then(() => setLoading(false))
        .catch(() => {
          setDialogMessage('Error');
          setDialogMessage('Error al cargar los detalles de la transferencia.');
          setIsDialogOpen(true);
          setLoading(false);
        });

      return () => {
        cleanDetailOpenPayAction();
      };
    }
  };

  const handleClose = () => {
    setIsDialogOpen(false);
    setIsDialogOpenDetails(false);
    cleanDetailOpenPayAction();
    if (transactionId) {
      onClose();
    }
  };

  const getStatusColor = (paymentStatus) => {
    switch (paymentStatus) {
      case 'Success':
        return 'green';
      case 'Fail':
        return 'red';
      case 'Review':
        return 'Orange';
      default:
        return 'purple';
    }
  };

  const translationMap = {
    Requested: 'Transacción registrada',
    Success: 'Transacción exitosa',
    Fail: 'Falló al procesar el pago',
    Review: 'En espera de revisión',
    Error: 'Error al procesar el pago',
  };

  const handleFraudPrevention = (data) => {
    setLoadingFraudAndChargeback(true);
    const payload = {
      txn_payment_id: data,
      descriptionTransaction,
      payment_provider_name: 'OPENPAY',
    };
    actionReportTransactionsFraud({ ...payload });
  };

  const handleChargebackPrevention = (data) => {
    setLoadingFraudAndChargeback(true);
    const payload = {
      txn_payment_id: data,
      descriptionTransaction,
      payment_provider_name: 'OPENPAY',
    };
    actionReportTransactionsChargeback({ ...payload });
  };

  const handleCloseFraudChargeback = () => {
    setOpenActionFraud(false);
    setDescriptionTransaction('');
    setError(false);
    setDialogMessage('');

    if (action === 'fraud') {
      cleanReportTransactionsFraud();
    } else if (action === 'chargeback') {
      cleanReportPrepaidChargebackDetails();
    }

    setLoading(true);

    openPayAction(page, size, searchParams)
      .then(() => setLoading(false))

      .catch(() => {
        setLoading(false);
      });
  };

  const handleOpenPopUp = (action, rowId) => {
    setAction(action);
    setSelectedRowId(rowId);
    setOpenActionFraud(true);
  };

  const handleConfirm = () => {
    if (descriptionTransaction === '') {
      setError(true);
    } else {
      setError(false);
      if (action === 'fraud') {
        handleFraudPrevention(selectedRowId);
      } else if (action === 'chargeback') {
        handleChargebackPrevention(selectedRowId);
      }
    }
  };

  useEffect(() => {
    if (reportTransactionsChargeback?.status === 200) {
      setDialogMessage('La operación se completó con éxito.');
      setIsError(false);
      setLoadingFraudAndChargeback(false);
      detailOpenPayAction(IdOrder);
    } else if (reportTransactionsChargeback?.payload?.response?.status > 200) {
      setLoadingFraudAndChargeback(false);
      setDialogMessage(
        reportTransactionsChargeback?.payload?.response?.data?.detail || 'Ha ocurrido un error.',
      );
      setIsError(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportTransactionsChargeback]);

  useEffect(() => {
    if (reportTransactionsFraud?.status === 200) {
      setDialogMessage('La operación se completó con éxito.');
      setIsError(false);
      setLoadingFraudAndChargeback(false);
      detailOpenPayAction(IdOrder);
    } else if (reportTransactionsFraud?.payload?.response?.status > 200) {
      setLoadingFraudAndChargeback(false);
      setDialogMessage(
        reportTransactionsFraud?.payload?.response?.data?.detail || 'Ha ocurrido un error.',
      );
      setIsError(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportTransactionsFraud]);

  const Columns = [
    {
      field: 'id',
      headerName: 'ID',
      width: 180,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <Button variant='outlined' onClick={() => handleIdButtonClick(params.row.id)}>
          {'Ver detalle'}
        </Button>
      ),
    },

    {
      field: 'prevention',
      headerName: 'Prevención',
      width: 200,
      headerAlign: 'center',
      renderCell: (params) => (
        <ActionLabels isFraud={params.row.is_fraud} isChargeback={params.row.is_chargeback} />
      ),
    },

    {
      field: 'created',
      headerName: 'Fecha DB',
      width: 250,
      align: 'center',
      headerAlign: 'center',
      valueGetter: (params) => {
        return convertToMexicoTime(params);
      },
    },
    {
      field: 'transaction_time',
      headerName: 'Fecha de transacción',
      width: 250,
      align: 'center',
      headerAlign: 'center',
      valueGetter: (params) => {
        return convertToMexicoTime(params);
      },
    },
    {
      field: 'installments',
      headerName: 'Mensualidades',
      width: 200,
      align: 'right',
      headerAlign: 'center',
      renderCell: (params) => {
        const value = params.value;
        return value === 1 ? 'Contado' : `${value} meses`;
      },
    },
    {
      field: 'payment_status',
      headerName: 'Estado de pago',
      width: 220,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <Chip
          label={translationMap[params.row.payment_status] || params.row.payment_status}
          style={{
            backgroundColor: getStatusColor(params.row.payment_status),
            color: 'white',
          }}
        />
      ),
    },

    {
      field: 'authorization_code',
      headerName: 'Autorización',
      width: 200,
      align: 'right',
      headerAlign: 'center',
    },
    {
      field: 'bank_name',
      headerName: 'Banco',
      width: 200,
      align: 'right',
      headerAlign: 'center',
    },
    {
      field: 'masked_card',
      headerName: 'Tarjeta',
      width: 200,
      align: 'right',
      headerAlign: 'center',
    },
    {
      field: 'amount',
      headerName: 'Monto',
      width: 120,
      align: 'right',
      headerAlign: 'center',
      renderCell: (params) => <CurrencyFormatter amount={params.value} />,
    },
    {
      field: 'transaction_number',
      headerName: 'Número de transacción',
      width: 210,
      align: 'right',
      headerAlign: 'center',
    },
    {
      field: 'message',
      headerName: 'Mensaje',
      width: 200,

      headerAlign: 'center',
    },
    {
      field: 'actions',
      headerName: 'Acciones',
      width: 200,
      headerAlign: 'center',
      renderCell: (params) => (
        <ActionsMenu
          onFraud={() => handleOpenPopUp('fraud', params.id)}
          onChargeback={() => handleOpenPopUp('chargeback', params.id)}
        />
      ),
    },
  ];

  return {
    register,
    handleSubmit,
    errors,
    onSubmit,
    loading,
    page,
    size,
    handleChangePage,
    pagination: {
      ...pagination,
      handleChangePage,
      handleChangePageSize,
    },
    rows,
    mappedRows,
    Columns,
    isDialogOpen,
    setIsDialogOpen,
    dialogMessage,
    handleClose,
    isDialogOpenDetails,
    errorMessage,
    setErrorMessage,
    handleConfirm,
    handleCloseFraudChargeback,
    openActionFraud,
    setDescriptionTransaction,
    setError,
    loadingFraudAndChargeback,
    error,
    isError,
    handleOpenPopUp,
    setLoading,
  };
};
